import loyaltyMenu from 'lmcv/modules/menu'

const menuList = ({ loyaltyProgramCode, loyaltyProRelationship }) => [
  {
    isActive: false,
    name: 'Resumo',
    link: '',
    glyph: 'silhouette'
  },
  {
    isActive: true,
    name: 'Meus Dados',
    link: '/minha-conta',
    glyph: 'user-data'
  },
  {
    isActive: true,
    name: 'Meus Pedidos',
    link: '/meus-pedidos',
    glyph: 'orders'
  },
  {
    isActive: true,
    name: 'Com Você',
    link: '/fidelidade',
    glyph: 'lmcv',
    submenu: loyaltyMenu({
      loyaltyProgramCode,
      loyaltyProRelationship
    })
  },
  {
    isActive: false,
    name: 'Notificações',
    link: '',
    glyph: 'bell'
  },
  {
    isActive: true,
    name: 'Lista de Favoritos',
    link: '/minhas-listas-de-desejos',
    glyph: 'heart'
  }
]

export default menuList
